<!-- Upload Input -->
<div class="flex flex-column h-full surface-card p-3" [ngClass]="inputClass">
  <div class="mb-3">
    <button medsurf-design-input-button [id]="'choose'"
        [label]="'global.choose' | translate"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.UPLOAD"
      (click)="onDropzoneClick()"></button>
  </div>

  <div class="dropzone px-3 flex flex-column overflow-auto border-400 border-dashed"
    style="flex-basis: 0; flex-grow: 1;"
    [class.border-transparent]="!dragover()"
    (dragover)="$event.preventDefault(); dragover.set(true)" 
    (dragleave)="dragover.set(false)" 
    (dragend)="dragover.set(false)" 
    (drop)="$event.preventDefault(); onDropzoneDrop($event)"
  >
    @if (sortedUploads().length) {
      <div>
        @for (upload of sortedUploads(); let index = $index; track upload.fileName) {
          <div class="py-3 my-3 relative">
            @if(upload.status === 'uploading') {
              <div class="bar w-full absolute surface-200 pt-1 top-0 left-0">
                <div class="w-full h-full absolute top-0 left-0 surface-600 origin-left" [style.transform]="`scaleX(${upload.progress / 100})`"></div>
              </div>
            }
            <div class="flex gap-2 align-items-center">
              <div class="w-3rem">{{ index + 1 }}</div>
              <div class="flex-grow-1">{{ upload.fileName }}</div>
              <div class="w-6rem">{{ upload.size | fileSize }}</div>
              <div class="w-8rem text-right">
                @if (upload.status === 'pending') {
                  <p-tag [value]="'primeng.pending' | translate" severity="info" />
                } @else if (upload.status === 'error') {
                  <p-tag [value]="'primeng.error' | translate" severity="danger" [pTooltip]="upload.error ? (upload.error.message | translate) : ''" />
                } @else if (upload.status === 'uploading') {
                  @if (upload.progress === 100) {
                    <p-tag [value]="'primeng.processing' | translate" severity="info">
                      <ng-template pTemplate="icon">
                        <i class="fa fa-spinner-third fa-spin"></i>
                      </ng-template>
                    </p-tag>
                  } @else {
                    <p-tag [value]="upload.progress + '%'" severity="info" />
                  }
                } @else if (upload.status === 'success') {
                  <p-tag [value]="'primeng.success' | translate" severity="success" />
                }
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="flex flex-1 flex-column justify-content-center align-items-center" (click)="onDropzoneClick()">
        <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.UPLOAD_BIG"></i>
        <div class="mt-4">{{ 'global.media_dropzone' | translate }}</div>
      </div>
    }
  </div>
</div>
